// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","image":"App_image__3byI1","footer":"App_footer__29Fsv"};